import { JSONContent } from '@tiptap/core';

import { ReasonToken, Recipient, UserRecipientAPIData } from '@bonusly/recipient-entities';

import { LexerToken } from './rich-text-lexer';

type Bonus = {
	receivers: UserRecipientAPIData[];
	reason_tokens?: ReasonToken[];
};

export class RichTextParser {
	constructor(
		public readonly tokens: LexerToken[] = [],
		private bonus?: Bonus
	) {}

	content(): JSONContent[] {
		return this.tokens.map((token) => {
			if (token.type === 'text') {
				return {
					type: token.type,
					text: token.value,
				};
			}

			if (token.type === 'recipient' && this.bonus && this.bonus.reason_tokens) {
				const reasonToken = this.bonus.reason_tokens.find((t: any) => t.token.substring(1) === token.value);
				if (reasonToken) {
					return {
						type: token.type,
						attrs: {
							id: token.value,
							record: Recipient.fromReasonToken(reasonToken, this.bonus.receivers),
						},
					};
				}
			}

			return {
				type: token.type,
				attrs: {
					id: token.value,
				},
			};
		});
	}

	document(): JSONContent {
		return {
			type: 'doc',
			content: [
				{
					type: 'paragraph',
					content: this.content(),
				},
			],
		};
	}
}
